import { create } from "zustand";

const INITIAL_SELECTED_PLAN_STATE = {
    clientId: null,
    planId: null,
    clientName: null,
    platformTab: null,
    planRow: null,
    importedPlanData: null,
    isReview: false,
};

export const useSelectedPlanStore = create((set) => ({
    ...INITIAL_SELECTED_PLAN_STATE,
    setSelectedPlan: (
        planRow,
        platformTab,
        { importedPlanData = null, isReview = false } = {},
    ) =>
        set({
            clientId: planRow?.clientId ?? null,
            planId: planRow?.planId ?? null,
            clientName: planRow?.clientName ?? null,
            platformTab,
            planRow: planRow ?? null,
            importedPlanData,
            isReview: Boolean(isReview),
        }),
    setImportedPlanData: (importedPlanData, isReview = true) =>
        set({
            importedPlanData: importedPlanData ?? null,
            isReview: Boolean(isReview),
        }),
    clearSelectedPlan: () => set(INITIAL_SELECTED_PLAN_STATE),
}));
